import React from 'react';
import FeaturesState from '../../domain/FeaturesState';
import {connect} from 'react-redux';
import {
    getFilteredComments,
    OrderedComments,
    isDeleteManyCommentsModalVisible,
    featureOrTypeForComments
} from '../../selectors';
import {
    OnNewFeatureComment,
    onNewFeatureComment, onNewFeatureTypeComment, OnNewFeatureTypeComment,
    setCommentsFilter,
    setCommentsModalVisible,
    setMarkedComments, setFeatureOrTypeIdForComments
} from '../../../../actions/actions';
import {Modal, ModalBody, ModalHeader} from 'react-bootstrap';
import CommentsModalFeatureTypeComments from './CommentsModalFeatureTypeComments';
import CommentsModalFooter from './CommentsModalFooter';
import CommentForm from '../CommentForm';
import {DisplayFeature, DisplayFeatureType} from '../../domain';

interface DeleteManyCommentsModalStateProps {
    visible: boolean;
    filteredComments: OrderedComments;
    featureOrTypeForComments: DisplayFeature | DisplayFeatureType | null;
}

interface DeleteManyCommentsModalDispatchProps {
    hide: () => void;
    resetFilter: () => void;
    resetMarked: () => void;
    resetSingleFeatureComment: () => void;
    addFeatureComment: OnNewFeatureComment;
    addFeatureTypeComment: OnNewFeatureTypeComment;
}

type DeleteManyCommentsModalProps = DeleteManyCommentsModalStateProps &
                                        DeleteManyCommentsModalDispatchProps;

class CommentsModal extends React.Component<DeleteManyCommentsModalProps, {}> {

    constructor(props: DeleteManyCommentsModalProps) {
        super(props);
        this.clear = this.clear.bind(this);
    }

    clear() {
        this.props.resetFilter();
        this.props.resetMarked();
        this.props.resetSingleFeatureComment();
        this.props.hide();
    }

    render() {

        const {visible} = this.props;

        return (
            <Modal onHide={this.clear} show={visible}>
                <ModalHeader>
                    <h1>Kommentarer</h1>
                </ModalHeader>
                <ModalBody>
                    {
                        Object.entries(this.props.filteredComments)
                            .map(([featureTypeId, filteredComment]) =>
                                <CommentsModalFeatureTypeComments
                                    key={featureTypeId}
                                    featureTypeName={filteredComment.featureTypeName}
                                    comments={filteredComment.comments}
                                    features={filteredComment.features}
                                />
                            )
                    }
                    {
                        this.props.featureOrTypeForComments && <CommentForm />
                    }
                </ModalBody>
                <CommentsModalFooter hide={this.clear} />
            </Modal>
        );
    }
}

const mapStateToProps = (state: FeaturesState): DeleteManyCommentsModalStateProps => ({
    visible: isDeleteManyCommentsModalVisible(state),
    filteredComments: getFilteredComments(state),
    featureOrTypeForComments: featureOrTypeForComments(state)
});

const mapDispatchToProps: DeleteManyCommentsModalDispatchProps = {
    hide: () => setCommentsModalVisible(false),
    resetFilter: () => setCommentsFilter(''),
    resetMarked: () => setMarkedComments([]),
    resetSingleFeatureComment: () => setFeatureOrTypeIdForComments(null),
    addFeatureComment: onNewFeatureComment,
    addFeatureTypeComment: onNewFeatureTypeComment
};

export default connect(mapStateToProps, mapDispatchToProps)(CommentsModal);
